import { Divider, Popover } from 'antd';
import { LoadingIcon } from 'components/Icons';
import Vocabulary from 'components/Vocabulary';
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';
import _ from 'lodash';
import React, { useEffect, useState, useCallback } from 'react'
import FindingAPI from 'restAPI/FindingAPI';
import ProductAPI from 'restAPI/ProductAPI';
import { formatNumber } from 'utils/numberUtil';
import ProductAndSubProductList from './ProductAndSubProductList';
import useUrlFilters from 'hooks/useUrlFilters';
import useDetectFilterChange from 'hooks/useDetectFilterChange';

export default function ProductSubProductCount({ businessUnitId }) {
    const [state, setState] = useState({});
    const [listData, setListData] = useState();
    const { globalFilterHash } = useGlobalFilterContext();

    const filters = useUrlFilters();
    const actualAppliedFilters = useDetectFilterChange(filters);

    const fetchData = useCallback(() => {
        setListData();
        const { promise, cancel } = ProductAPI.getAllProductsByBU(businessUnitId);
        promise
            .then(setListData)
            .catch((err) => {
                console.error(err);
                setListData([]);
            })
        return cancel;
    }, [businessUnitId])

    useEffect(fetchData, [fetchData])

    useEffect(() => {
        setState(state => {
            if (_.isEmpty(state)) {
                return state;
            }
            return {};
        });
        // Wait until the products by BU API is completed to avaoid unwanted cancelling of API.
        if (_.isUndefined(listData)) {
            return;
        }

        const data = {
            fields: [
                "product", "subProduct"
            ],
            filters : actualAppliedFilters
        };
        const productApiRequest = FindingAPI.getGroupStats({ aggField: "product", filters: data.filters });
        const subProductApiRequest = FindingAPI.getGroupStats({ aggField: "subProduct", filters: data.filters });
        // ENG-50451 - fetching product subproduct count seperately due to BE limitation of processing only 1000 entries max
        // so the finding filters return max 1000 subproducts
        const apiRequest2 = FindingAPI.getStatsMetric({
            filters: data.filters,
            aggField: "product"
        });
        const apiRequest3 = FindingAPI.getStatsMetric({
            filters: data.filters,
            aggField: "subProduct"
        });
        Promise.all([productApiRequest.promise, subProductApiRequest.promise, apiRequest2.promise, apiRequest3.promise]).then(([productData, subProductData, productMetric, subproductMetric]) => {
            const prodIds = Object.keys(productData).map(Number);
            const subProIds = Object.keys(subProductData).map(Number);
            const list = _.map(listData, l => {
                if (_.includes(prodIds, l.product.id)) {
                    const orgSubProd = { product: l.product,
                                         subProducts: l.subProducts.filter(sub => _.includes(subProIds, sub.id))};
                    return orgSubProd;
                }
                return null;
            })
            setState({
                listing: _.compact(list),
                productCount: productMetric.aggFieldUniqueCount ?? 0,
                subproductCount: subproductMetric.aggFieldUniqueCount ?? 0
            })
        }).catch(function () {
            setState({
                listing:[],
                productCount: 0,
                subproductCount: 0,
            })
        });
        return () => {
            productApiRequest.cancel();
            subProductApiRequest.cancel();
            apiRequest2.cancel();
            apiRequest3.cancel();
        };

    }, [listData, globalFilterHash, actualAppliedFilters]);

    const { productCount, subproductCount, listing} = state;    
    return (
        <Popover content={<ProductAndSubProductList listing={listing} />} trigger="click" placement="bottomLeft" onClick={e => e.stopPropagation()}>
            <div className="text-bold m-r-m">
                <Vocabulary name="product" isPlural={true} />: {_.isUndefined(productCount) ? <LoadingIcon /> : formatNumber( productCount)}
                <Divider type="vertical" />
                <Vocabulary name="subProduct" isPlural={true} />: {_.isUndefined(subproductCount) ? <LoadingIcon /> : formatNumber( subproductCount)}
            </div>
        </Popover>
    )
}